import { useRosterFocusStore } from "@/store/rosterFocusStore";

function TdSummaryPerNurse({ code, count }: { code: string; count: number }) {
  const columnKey = `shift${code}`;
  const isHovered = useRosterFocusStore((s) => s.hoveredColumn === columnKey);
  const isSelected = useRosterFocusStore((s) => s.selectedColumn === columnKey);
  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);

  const highlightBg = isSelected
    ? "rgba(169, 223, 254, 0.4)"
    : isHovered
      ? "rgba(169, 223, 254, 0.3)"
      : undefined;

  return (
    <div
      className="rt_cell flex shrink-0 flex-col justify-center "
      style={{
        width: "var(--shiftCode_size)",
        ...(highlightBg != null ? { backgroundColor: highlightBg } : {}),
      }}
      data-column={columnKey}
    >
      <div
        className="size-7.5 border rounded-sm  flex items-center justify-center text-sm text-zinc-500 font-normal"
        onMouseEnter={() => {
          setHoveredFocus({ column: columnKey, nurseId: "" });
        }}
        onMouseLeave={() => {
          clearHoveredFocus();
        }}
      >
        {count}
      </div>
    </div>
  );
}

export default TdSummaryPerNurse;
